import { IconComponent } from 'design-system/types'

export const CommunityIcon: IconComponent = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M4.25 8.5c1.79 0 3.25-1.46 3.25-3.25S6.04 2 4.25 2 1 3.46 1 5.25 2.46 8.5 4.25 8.5Zm0-4.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM6 20H4.11l-.62-4.15A.993.993 0 0 0 2.5 15H2v-2c0-1.1.9-2 2-2 .55 0 1-.45 1-1s-.45-1-1-1c-2.21 0-4 1.79-4 4v3c0 .55.45 1 1 1h.64l.62 4.15c.07.49.49.85.99.85H6c.55 0 1-.45 1-1s-.45-1-1-1ZM19.75 8.5C21.54 8.5 23 7.04 23 5.25S21.54 2 19.75 2 16.5 3.46 16.5 5.25s1.46 3.25 3.25 3.25Zm0-4.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM20 9c-.55 0-1 .45-1 1s.45 1 1 1c1.1 0 2 .9 2 2v2h-.5c-.5 0-.92.36-.99.85L19.89 20H18c-.55 0-1 .45-1 1s.45 1 1 1h2.75c.5 0 .92-.36.99-.85l.62-4.15H23c.55 0 1-.45 1-1v-3c0-2.21-1.79-4-4-4ZM12 7c1.93 0 3.5-1.57 3.5-3.5S13.93 0 12 0 8.5 1.57 8.5 3.5 10.07 7 12 7Zm0-5c.83 0 1.5.67 1.5 1.5S12.83 5 12 5s-1.5-.67-1.5-1.5S11.17 2 12 2Z"
      fill="currentColor"
    />
    <path
      d="M18 16v-2c0-3.31-2.69-6-6-6s-6 2.69-6 6v2c0 .55.45 1 1 1h1.1l.65 6.11c.05.51.48.89.99.89h4.5c.51 0 .94-.39.99-.89l.65-6.11h1.1c.55 0 1-.45 1-1H18Zm-2-1h-1c-.51 0-.94.39-.99.89L13.36 22h-2.7l-.65-6.11a.989.989 0 0 0-.99-.89h-1v-1c0-2.21 1.79-4 4-4s4 1.79 4 4v1H16Z"
      fill="currentColor"
    />
  </svg>
)
